"use strict";

exports.__esModule = true;
exports.default = void 0;
var _index = require("./index");
var _WebRequestHelper = require("./WebRequestHelper");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class JoinActionHelper {
  constructor(localName, foreignName, options = {
    singular: null,
    plural: null,
    params: {}
  }) {
    _defineProperty(this, "create", (body, params, module, useAuthentication = true) => {
      return dispatch => {
        return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
          request.method = "post";
          request.url = `${this._uri}${(0, _index.paramsToString)(params)}`;
          request.data = body;
          console.log(request);
          return (0, _WebRequestHelper.sendRequest)(request).then(response => {
            dispatch({
              type: `CREATE_` + this._SINGULAR + `_SUCCESS`,
              data: response.data
            });
            return response.data;
          }).catch(error => {
            console.dir(error);
            dispatch({
              type: `CREATE_${this._SINGULAR}_FAILURE`,
              data: error
            });
            if (error.response && error.response.data) throw error.response.data;
            throw error;
          });
        }).catch(err => console.dir(err));
      };
    });
    _defineProperty(this, "destroy", (id, module, useAuthentication = true) => {
      return dispatch => {
        return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
          request.method = "delete";
          request.url = `${this._uri}/${id}`;
          return (0, _WebRequestHelper.sendRequest)(request).then(response => {
            dispatch({
              type: `DELETE_${this._SINGULAR}_SUCCESS`,
              data: {
                Id: id
              }
            });
            return true;
          }).catch(error => {
            console.dir(error);
            dispatch({
              type: `DELETE_${this._SINGULAR}_FAILURE`,
              data: error
            });
            if (error.response && error.response.data) throw error.response.data;
            throw error;
          });
        }).catch(err => console.dir(err));
      };
    });
    this._localName = localName;
    this._foreignName = foreignName;
    this._joinName = this._localName + this._foreignName.charAt(0).toUpperCase() + this._foreignName.slice(1);
    this._singular = options.singular || this._joinName;
    this._plural = options.plural || this._joinName.charAt(this._joinName.length - 1).toLowerCase() === "y" ? this._joinName.slice(0, -1) + "ies" : this._joinName + "s";
    this._uri = this._foreignName.charAt(this._foreignName.length - 1).toLowerCase() === "y" ? this._uri = "/" + this._localName + this._foreignName.slice(0, -1) + "ies" : this._uri = "/" + this._localName + this._foreignName + "s";
    this._SINGULAR = this._singular.toUpperCase();
    this._PLURAL = this._plural.toUpperCase();
  }
}
var _default = exports.default = JoinActionHelper;
module.exports = exports.default;